export default {"src":"/_next/static/media/telegram-icon.430bd7fb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};